import React, { Component, PropType } from 'react';
import LoadingComponent from '../../commonComponents/LoadingComponent';
import NoDataFound from '../../commonComponents/NoDataFound';
import SummaryMessage from './SummaryMessage';
// import axios from 'axios';
var base64 = require('base-64');
import { DBService } from './IndexedDB';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';

// Comment
var chartStyle = {
    height: '350px',
    width: '100%'
};
var downloadStyle = {
    cursor: 'pointer',
    width: '40px',
    marginRight: '15px',
    marginTop: '-16px'
}

class SummaryData extends React.Component {

    constructor(props) {
        super(props);
        this.state = { summary: null, breakup: props.breakUp, property: props.category, metricRange: '', i: 0, drillHandle: props.drillHandle, metricGlobal: props.metricGlobal, metricFunction: props.metricFunction }
        this._db = new DBService();
        this.stateSetFromResponse = this.stateSetFromResponse.bind(this);
    }

    _deleteData(params){
        this._db.delete("Response", params).then(e => {
            console.log("Data Deleted!")
            this.setState({ data: e })
        })
    }

    componentDidCatch(error, info) {
        this.setState({
            pageError: true
        })
    }

    componentWillMount () { 
        this.componentWillReceiveProps(this.props);

    }
    componentDidMount(){
        if (this.props.index != 1)
           dragcomplete();
    }
    componentDidUpdate(){
        if (this.props.index != 1)
           dragcomplete();
    }
    stateSetFromResponse(response, nextProps) {
        let that = this;
        if (response.status) {
            var status = response.status;
            if (status == "No Access for the Column") {
                that.setState({
                    summary: status
                })
            }
        } else {
            var responseStartDate = null;
            var responseEndDate = null;
            if (response == null || response.length == 0)
                response = 0;
            else {
                let questionExplain = response.explain;
                jQuery("#questionExplain").html(questionExplain);
                if (response.date) {
                    response.date = response.date[0] ? response.date[0] : response.date;
                    responseStartDate = response.date['startDate'];
                    responseEndDate = response.date['endDate'];
                }
            }
            if (response.minMaxData) {
                var temp = addMinMaxDataToMetricDisp(that.props.selectedMetricDisp, response.minMaxData[0], nextProps.metricRange);
                that.props.handleChange('metricDisp', temp);
            }
            var summartData = response.data;
            var summaryShortName = response.shortName
            if (this.props.index) {
                summaryData[this.props.index] = summartData;
            } else {
                summaryData["comp"] = summartData
            }
            var runrate = getRunrateGranAndYear();
            var runrateYear = null;
            var runrateGran = null;
            if (runrate) {
                runrateYear = runrate['year'];
                runrateGran = runrate['gran'];
            }
            that.setState({
                summary: summartData,
                cagrDate : response.cagrDate,
                metrics: nextProps.metrics,
                selectedMetric: nextProps.selectedMetric,
                metricRange: nextProps.metricRange,
                property: nextProps.category,
                breakup: nextProps.breakUp,
                periodComparison: nextProps.periodComparison,
                outputType: nextProps.outputType,
                isInsight: nextProps.isInsight,
                startDate: nextProps.startDate,
                endDate: nextProps.endDate,
                // hideGrowth: response.flag.showSummaryGrowth,
                hideGrowth: false,
                growthStartDate: responseStartDate,
                growthEndDate: responseEndDate,
                runrateYear: runrateYear,
                runrateGran: runrateGran,
                summaryShortName: summaryShortName
            });
        }
    }
    componentWillReceiveProps(nextProps, ...rest) {
        var indexedDB = this._db
        var that = this;
        if (!that.state.i || !that.arePrevAndThisPropsEqual(that.props, nextProps)) {
            that.setState({
                summary: null,
                i: that.state.i + 1,
                drillHandle: nextProps.drillHandle,
            });
            var startDate = moment(nextProps.startDate, 'YYYY-MM-DD').format(dateFormatToSend1);
            var endDate = moment(nextProps.endDate, 'YYYY-MM-DD').format(dateFormatToSend2);
            var verifyEndDate = moment(nextProps.endDate).endOf('Month').format('YYYY-MM-DD');
            endDate = endDate > verifyEndDate ? verifyEndDate : endDate; 
            setCacheFlag([]);
            if (nextProps.selectedMetric) {
                const dataSetDetails = JSON.parse(localStorage.Dataset)
                const userId = this.props.authData ? this.props.authData.userId : null;
                const authorization_value = "Basic " + base64.encode(userId + ":");
                var parameters = {
                    siteId: dataSetDetails.siteId, toolId: nextProps.toolId ? nextProps.toolId : dataSetDetails.toolId,
                    startDate: startDate, endDate: endDate, selectedProperty: nextProps.category, selectedPropertyValue: '', breakUp: nextProps.breakUp, selectedMetric: nextProps.selectedMetric, summary: '', calculateGrowth: true, dashboard: true, range: nextProps.metricRange, periodComparison: nextProps.periodComparison, outputType: nextProps.outputType, isInsight: nextProps.isInsight, includeBreakUp: refineURLData(nextProps.include), excludeBreakUp: nextProps.exclude, chart: 'Table', returnType: "total", type: "summary", sortMetric: nextProps.sortMetric, cagrPoint: nextProps.cagrPoint,removeGlobalFilter:nextProps?.removeGlobalFilter,prevStartDate:nextProps?.prevStartDate,prevEndDate:nextProps?.prevEndDate,ytdcagr:nextProps?.ytdcagr || ""
                }
                //indexedDB code
                var idbParams = JSON.parse(JSON.stringify(parameters));
                idbParams['userId'] = userId
                idbParams['globalFilters'] = nextProps.globalFilters
                idbParams['prevStartDate'] = nextProps?.prevStartDate
                idbParams['prevEndDate'] = nextProps?.prevEndDate

                var response = null;
                indexedDB.get("SummaryData", JSON.stringify(idbParams)).then(e => {
                    if (e) {
                        response = that.handleData(JSON.parse(e.object));
                        checkIfMaintenanceModeOn(response)
                        that.stateSetFromResponse(response, nextProps);
                    } else {
                        CallAPI('GET', '/app/v1/trendChart', null, parameters, 0, function (response) {
                            if(is500Error(response)) {
                                that.setState({
                                    pageError: true,
                                    summary: 0,
                                    response: response
                                })
                            } else {
                                setCacheFlag(response);
                                var resultData = JSON.stringify(response)
                                indexedDB.put("SummaryData", resultData, JSON.stringify(idbParams))
                                response = that.handleData(response);
                                that.stateSetFromResponse(response, nextProps);
                            }                            
                        }, this.props.authData)

                        /* Commented below axios api call & changed it to above CallAPI method */
                        // let callAPIParams = {
                        //     headers: { Authorization: authorization_value },
                        //     params: parameters
                        // }
                        // let url = "/app/v1/trendChart"
                        // axios.get(url, callAPIParams).then(initialResponse => {
                        //     response = initialResponse.data
                        //     setCacheFlag(response);
                        //     var resultData = JSON.stringify(response)
                        //     indexedDB.put("SummaryData", resultData, JSON.stringify(callAPIParams['params']))
                        //     response = this.handleData(response);
                        //     that.stateSetFromResponse(response, nextProps);
                        // }).catch(error => {
                        //     if(error.request.status === 408) {
                        //         alert("Session Timed Out. Please login again.");
                        //         logoutHandle(true);
                        //     } else {
                        //         alert(`${error.response.status}: Server Error, please try again later`);
                        //     }  
                        // })
                    }
                })
            } else {
                // if selected metric doesn't exist
                this.setState({ summary: 2 })
            }
        }
    }
    handleData (summaryData){
        var temp_result = {};
        temp_result['data'] = summaryData.data.result;
        temp_result['cagrDate'] = summaryData?.parameter_cache?.date
        temp_result['flag'] = { showChartSummary: 1, showSummaryGrowth: 1 };
        temp_result['shortName'] = summaryData.shortName
        return temp_result;
    }
    arePrevAndThisPropsEqual (prevProps, nextProps) {
        if (prevProps.breakUp == nextProps.breakUp && prevProps.category == nextProps.category && prevProps.categoryValue == nextProps.categoryValue && prevProps.selectedMetric == nextProps.selectedMetric && prevProps.startDate == nextProps.startDate && prevProps.endDate == nextProps.endDate && prevProps.metricRange == nextProps.metricRange && prevProps.periodComparison == nextProps.periodComparison && prevProps.outputType == nextProps.outputType && prevProps.include == nextProps.include && prevProps.exclude == nextProps.exclude  && (prevProps.prevStartDate == nextProps.prevStartDate || prevProps.prevStartDate == nextProps?.allData?.props?.prevStartDate) && (prevProps.prevEndDate == nextProps?.prevEndDate || prevProps.prevEndDate == nextProps?.allData?.props?.prevEndDate) && prevProps?.sortMetric == nextProps?.sortMetric && prevProps?.cagrPoint == nextProps?.cagrPoint) {
            return true;
        }
        else
            return false;
    }

    render () {
        var that=this;
        var hideGrowth = this.state.hideGrowth;
        var selectedMetric = this.state.selectedMetric;
        selectedMetric = selectedMetric ? selectedMetric : this.props.selectedMetric;
        var breakup = this.state.breakup;
        breakup = breakup ? breakup : this.props.breakup;
        var property = this.state.property;
        var preposition = 'by';
        var isDashboard = this.props.isDashboard;
        property = property ? property : this.props.property; 
        var propertyCount = property ? (property.split(',')).length : 0;
        if(propertyCount == 1 && property.split(';')[1]) {
            preposition = property.split(';')[1] == 'overall' ? 'at' : 'for';
        }
        var periodComparison = this.state.periodComparison;
        var outputType = this.state.outputType;
        outputType = outputType ? outputType : this.props.outputType;
        var startDate = this.state.startDate;
        startDate = startDate ? startDate : this.props.startDate;
        var endDate = this.state.endDate;
        endDate = endDate ? endDate : this.props.endDate;
        var growthStartDate = this.state.growthStartDate;
        var growthEndDate = this.state.growthEndDate;
        var runrate = false;
        selectedMetric = selectedMetric == undefined || selectedMetric == ''
            ? ''
            : selectedMetric.split(",");
        var nonSelected = [];
        var selected = [];
        var pinFilter = this.props.pinFilter;
        if (this.state.summary != null) {
            var flag = this.props.recommendation;
            
            if((this.props.pageError || this.state.pageError) && this.state.summary == 0) {
                let is500 = this.state.response && this.state.response['error_code'] == 500 ? true : false                
                let information = this.state.response && this.state.response['information'] ? this.state.response['information'] : null
                let status = this.state.response && this.state.response['status'] ? this.state.response['status'] : null
                resetFilterGo();
                resetAppliedFilterFlag();
                return (<NoDataFound hideImg={true} is500={is500} status={status} information={information} response={this.state.response}/>);
            }
            else if (this.props.itemDetails && typeof this.props.itemDetails.parameters !== 'object' && IsJsonString(this.props.itemDetails.parameters) == false && this.state.summary == 2) {
                return (<NoDataFound hideImg={true} is500={true} />);
            }
            else if (this.state.summary == 0) {
                resetFilterGo();
                resetAppliedFilterFlag();
                return (<NoDataFound />);
            }                
            else if (this.state.summary == 2) {
                resetFilterGo();
                resetAppliedFilterFlag();
                return (<NoDataFound data='Please set a filter with atleast 1 metric to see summary' />);
            }                
            else if (this.state.summary == "No Access for the Column") {
                resetFilterGo();
                resetAppliedFilterFlag();
                return (<NoDataFound data="You don't have access to the mentioned Property. Please contact admin for the access." />);
            }                
            else if (selectedMetric == '' || selectedMetric == null) { 
                return (
                    <div>
                        {this.state.summary.map(function (value, index) {
                            var data = [];
                            data['data'] = value.data;
                            data['metric'] = value.description;
                            data['growth'] = value.growth;
                            data['absolute'] = value.absolute;
                            data['previous_value'] = value['previous_value']; 
                            return (<SummaryMessage
                                data={data}
                                toolTip='Growth Rate (Compared to previous period)'
                                key={index}
                                id={index}
                                breakup={breakup}
                                include={that.props.include}
                                exclude={that.props.exclude}
                                property={property}
                                hideGrowth={hideGrowth}
                                periodComparison={periodComparison}
                                outputType={outputType}
                                drillHandle={that.state.drillHandle}
                                startDate={startDate}
                                endDate={endDate}
                                growthStartDate={growthStartDate}
                                growthEndDate={growthEndDate}
                                pinFilter={pinFilter}
                                insightPoint={that.props.insightPoint}
                                runrateGran={that.state.runrateGran}
                                runrateYear={that.state.runrateYear}
                                isDashboard={isDashboard}
                                index={that.props.index}
                                mainMetric={that.props.mainMetric}
                                componentData={that.props}
                                summaryShortName={that.state.summaryShortName}
                            />);
                        })}
                    </div>
                );
            } else {
                if (this.state.summary != undefined) {                     
                    var summary = this.state.summary;                    
                    if(this.state.outputType == 'runrate;0' || this.state.outputType == 'runrate;1' || this.state.outputType == 'projection') {
                        var temp = [];
                        temp['data'] = summary.data;
                        temp['metric'] = summary.metric;
                        temp['description'] = summary.description;
                        temp['growth'] = summary.growth;
                        temp['absolute'] = summary.absolute;
                        temp['previous_value'] = summary.previous_value;
                        selected.push(temp);
                        summary = selected;
                        runrate = true;
                    } else {
                        selectedMetric.forEach(function (key, metricValue) {
                            summary
                                .map(function (value) {
                                    if (key == value.description) {
                                        selected.push(value);
                                    }
                                });
                        });
                        summary.map(function (value) {
                            selectedMetric
                                .forEach(function (key, metricValue) {
                                    if (!in_array(value.description, selected) && !in_array(value.description, nonSelected)) {
                                        nonSelected.push(value);
                                    }
                                });
                        });
                    }
                }
                var detail1 = null;
                var detail1_hover = '';
                if (this.props.metricText && this.props.propertyText) {
                    detail1 = <div>{this.props.metricText + " "}
                        {preposition} {this.props.propertyText}</div>;
                    detail1_hover = this.props.metricText + " " + preposition + " " + this.props.propertyText;
                }                    
                const parsedData = JSON.parse(this.props?.dataSet?.userDBSetting?.[0]?.information || '{}');
                const isFilterNew = parsedData?.filterInformation ? parsedData?.filterInformation : "0";
    

                    
                var detail2 = [];
                var detail2_hover = '';
                if (this.props.breakupText) {
                    let breakupList = this.props?.breakUp?.split(',');
    
                    detail2.push(<><span>Filtered by {isFilterNew == '0' ?
                        breakupList &&   breakupList.map((item, index) => {
                            const [brand] = item.split(";"); // Split the string and take the first part
                            return <span class="badge badge-light tx-13 mg-l-5" >{brand}</span>;
                        })
                        : this.props.breakupText}</span><br /></>);
                    detail2_hover = "Filtered by " + this.props.breakupText;
                }

                var detail_include = [];
                var detail_include_hover = '';
                if (this.props.includeText) {
                    let includeList = this?.props?.include?.split(',');
    
                    detail_include.push(<><span>Included: {isFilterNew == '0' ?
                        includeList &&  includeList.map((item, index) => {
                            const [brand] = item.split(";"); // Split the string and take the first part
                            return <span class="badge badge-light tx-13 mg-2" >{brand}</span>;
                        })
                        : this.props.includeText}</span><br/></>);
                    detail_include_hover  = "Included: " + this.state.includeText;
                }
                
                var detail_exclude = [];
                var detail_exclude_hover = '';
                if (this.props.excludeText) {
                    let excludeList = this?.props?.exclude?.split(',');
    
                    detail_exclude.push(<><span>Excluded: {isFilterNew == '0' ?
                        excludeList.map((item, index) => {
                            const [brand] = item.split(";"); // Split the string and take the first part
                            return <span class="badge badge-light tx-13 mg-2" >{brand}</span>;
                        })
                        : this.props.excludeText}</span><br/></>);
                detail_exclude_hover += "Excluded: " + this.state.excludeText;
                    }

                var detail3 = null, dashboardDateInfo = null;
                var detail3_hover = '';
                if (startDate && endDate){
                    if(granularity=="month")
                        var formatDateFunction = "MMMM, YYYY";//formatting the date time in description area
                    else var formatDateFunction = "MMMM DD, YYYY";//formatting the date time in description area
                    detail3 = dashboardDateInfo = <div>Date: {moment(startDate,'YYYY-MM-DD').format(formatDateFunction)} to {moment(endDate,'YYYY-MM-DD').format(formatDateFunction)}</div>;
                    detail3_hover = "Selected Date: " + moment(startDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(endDate, 'YYYY-MM-DD').format(formatDateFunction);
                    if(this.props?.metric?.includes('cagr')||this.props?.selectedMetric?.includes('cagr')){
                        var cagrDate = dashboardDateInfo = "CAGR Calculation Date: " + moment(this.state?.cagrDate?.startDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.state?.cagrDate?.endDate, 'YYYY-MM-DD').format(formatDateFunction);
                        }
                    if(this?.props?.prevStartDate && this?.props?.prevEndDate){
                            var previousPeriodDate =  "Compared Date: " + moment(this?.props?.prevStartDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this?.props?.prevEndDate, 'YYYY-MM-DD').format(formatDateFunction);
                            }
                            
                }

                var globalFilter_details = null
                if (this.props.globalFilters && this.props.globalFilters.length > 0) {
                    globalFilter_details =  getGlobalFilterDetails(this.props.globalFilters)

                }
                if (detail3) {
                    var final_details_hover = detail3_hover + "<br>" + detail1_hover + "<br>" + detail2_hover + "<br>" + detail_include_hover + "<br>" + detail_exclude_hover;

                    var final_details = (
                        <span
                            className={`tx-13 ${isFilterNew == '0' && this.props.globalFilters && this.props.globalFilters.length > 0 ? "" : "link-03"}`}
                            style={{ fontWeight: isFilterNew == '0' ? "bold" : "" }}
                        >
                            {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? cagrDate : null}
                            {detail3}
                            {previousPeriodDate ? previousPeriodDate : null}
                            {previousPeriodDate ? <br />
                                : null}
                            {detail1}
                            {detail2}
                            {detail_include}
                            {detail_exclude}
                            {isFilterNew == "0" && this.props?.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? (
                                <>
                                    Global Filter: 
                                    {this.props.globalFilters.map((innerdata) => (
                                        <span className="badge badge-info tx-13 mg-2" style={{ backgroundColor: "#ADD8E6", color: "black" }}>
                                            {innerdata.label}
                                        </span>
                                    ))}
                                </>
                            ) : (
                                this.props?.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? globalFilter_details : null
                            )}
                        </span>
                    );
                }
                if(dashboardDateInfo) {
                    dashboardDateInfo = <span className='tx-13 link-03'>{dashboardDateInfo}</span>;
                }
                // if(isDashboard){
                //     var pinboard_final_details=<a>Show Filter Information</a>;
                // }
                    
                    
                var pop_over = selected.length==1?true:false;
                
                var tableTitle=null;
                var content=null;
                let mobile = jQuery(window).width()<=mobile_width;
                var classNameAdd = `row row-xs`;
                var footerClassName = "col-md-12"; 
                let metricData = getMetricData(this.state.selectedMetric.split(','), metricGlobal, metricFunction)
                if (this.props.chartTitle){ 
                    tableTitle = <div className="card-header pd-2"> {this.props.chartTitle} </div>
                    // classNameAdd = "card";
                    classNameAdd = "";
                    footerClassName = "card-footer";
                    content = <div className="row row-xs mg-l-0 mg-r-0">
                        {selected.map(function (value, index) {
                            var data = [];
                            data['data'] = value.data;
                            data['metric'] = runrate ? value.metric: value.description;
                            data['description'] = value.description;                            
                            data['growth'] = value.growth;
                            data['absolute'] = value.absolute;
                            data['previous_value'] = value['previous_value'];
                            data['metricData'] = metricData[value.description]
                            data['allData'] = value; 
                            return (<SummaryMessage
                                data={data}
                                id={index}
                                breakup={breakup}
                                include={that.props.include}
                                exclude={that.props.exclude}
                                property={property}
                                hideGrowth={hideGrowth} 
                                periodComparison={periodComparison}
                                outputType={outputType}
                                drillHandle={that.state.drillHandle}
                                startDate={startDate}
                                endDate={endDate}
                                growthStartDate={growthStartDate}
                                growthEndDate={growthEndDate}
                                recommendation= {flag}
                                pinFilter={pinFilter}
                                insightPoint={that.props.insightPoint}
                                runrateGran={that.state.runrateGran}
                                runrateYear={that.state.runrateYear}
                                pop_over={pop_over}
                                isDashboard={isDashboard}
                                index={that.props.index}
                                mainMetric={that.props.mainMetric}
                                componentData={that.props}
                                summaryShortName={that.state.summaryShortName}
                                final_details={final_details}
                                insight={that.props.insight}
                                />);
                        })}
                    </div>
                }
                else content=selected.map(function (value, index) {
                    var data = [];
                    data['data'] = value.data;
                    data['metric'] = runrate ? value.metric: value.description;
                    data['description'] = value.description;
                    data['growth'] = value.growth;
                    data['absolute'] = value.absolute;
                    data['previous_value'] = value['previous_value']; 
                    data['metricData'] = metricData[value.description]
                    data['allData'] = value;  
                    return (<SummaryMessage
                        data={data}
                        id={index}
                        breakup={breakup}
                        include={that.props.include}
                        exclude={that.props.exclude}
                        property={property}
                        hideGrowth={hideGrowth} 
                        periodComparison={periodComparison}
                        outputType={outputType}
                        drillHandle={that.state.drillHandle}
                        startDate={startDate}
                        endDate={endDate}
                        growthStartDate={growthStartDate}
                        growthEndDate={growthEndDate}
                        recommendation= {flag}
                        pinFilter={pinFilter}
                        insightPoint={that.props.insightPoint}
                        runrateGran={that.state.runrateGran}
                        runrateYear={that.state.runrateYear}
                        pop_over={pop_over}
                        isDashboard={isDashboard}
                        mainMetric={that.props.mainMetric}
                        componentData={that.props}
                        summaryShortName={that.state.summaryShortName}
                        insight={that.props.insight}
                        />);
                });

                var footerElement = <div className={footerClassName} >
                    {final_details}
                </div>;
                
                if (this.props.index && this.props.index != 1){
                    let displayValue = this.props.report_type && this.props.report_type == 'static' ? 'show' : 'none'
                    // displayValue = this.props.dashboard && this.props.dashboard_config && this.props.dashboard_config['information'] ? 'show' : 'none';

                    footerElement = <p className="card-footer pd-5 dashboard_footer_class slideInUp animated faster" id={"dashboard_footer_"+this.props.index} style={{  bottom: '0', maxHeight: '100px', backgroundColor: 'white', margin: '0px', width: "100%", display: displayValue }} >
                        {this.props.recommendation ? dashboardDateInfo : final_details}
                    </p>;
                    isDashboard=true;
                    // <p className="card-footer pd-10 dashboard_footer_class slideInUp animated faster" id={"dashboard_footer_"+this.props.index} style={{ position: 'absolute', bottom: '0', maxHeight: '100px', backgroundColor: '#e1e5ee', margin: '0px', width: "100%", display: "none" }}>{this.props.final_details}</p>
                }
                
                // Test comment
                return (
                    <div className='d-flex flex-column justify-content-between h-100'>
                    <div className={classNameAdd}>
                            {this.props.ExportComponentVar}
                            {/* {tableTitle} */}
                            {content}
                            {/* tooltip for Summary info: data-toggle="tooltip" title={final_details_hover} data-html="true" */}
                            {/* <div className={footerClassName} >
                                {final_details}
                            </div> */}
                            {/* <div className="box col-md-12">
                                {detail3}
                                {detail1}
                                {detail2}
                            </div> */}
                        </div>
                        <div>
                            {isDashboard ? footerElement : <div className="col-md-12 pd-l-0">{final_details}</div>}
                        </div>
                    </div>

                );
            }
        }
        return (<LoadingComponent component="summary"/>);
    }
};


function in_array(value, Arr) {
    for (var i in Arr) {
        if (Arr[i].description == value)
            return true;
    }
    return false;
}

export default SummaryData;